const careerBn = {
	breadcrumbs: { home: 'হোম', career: 'ক্যারিয়ার' },
	hero: {
		title: 'আপনার স্বপ্নের ক্যারিয়ার শুরু করুন',
		subtitle: 'গ্রামীণ বাজারে যোগ দিন এবং বাংলাদেশের গ্রামীণ কেনাকাটার অভিজ্ঞতাকে ডিজিটাল যুগে রুপান্তরের বিপ্লবে অবদান রাখুন'
	},
	companyStats: [
		{ value: '৫০০+', label: 'কর্মচারী' },
		{ value: '১০+', label: 'অফিস' },
		{ value: '৯৮%', label: 'কর্মচারী সন্তুষ্টি' },
		{ value: '১০০+', label: 'প্রশিক্ষণ প্রোগ্রাম' }
	],
	jobsSection: { title: 'চাকরির সুযোগ', subtitle: 'আমাদের সাথে কাজ করুন এবং আপনার ক্যারিয়ার গড়ুন' },
	labels: {
		featured: 'ফিচার্ড',
		postedSuffix: 'পোস্ট করা হয়েছে',
		salary: 'বেতন',
		deadline: 'আবেদনের শেষ তারিখ'
	},
	buttons: {
		viewDetails: 'বিস্তারিত দেখুন',
		apply: 'আবেদন করুন',
		cancel: 'বাতিল',
		submit: 'আবেদন জমা দিন',
		contact: 'যোগাযোগ করুন'
	},
	cta: {
		title: 'আপনার উপযুক্ত পজিশন খুঁজে পাচ্ছেন না?',
		subtitle: 'আমাদের সাথে যোগাযোগ করুন। আমরা নতুন সুযোগ সম্পর্কে আপনাকে জানাবো।',
		contact: 'যোগাযোগ করুন'
	},
	form: {
		titleSuffix: ' - আবেদন ফর্ম',
		name: 'নাম',
		email: 'ইমেইল',
		phone: 'ফোন',
		education: 'শিক্ষাগত যোগ্যতা',
		experience: 'কর্ম অভিজ্ঞতা',
		uploadResume: 'রিজুমে আপলোড করুন (PDF, DOC, DOCX)'
	},
	snackbar: { success: 'আপনার আবেদন সফলভাবে জমা হয়েছে। আমরা শীঘ্রই যোগাযোগ করব।' }
};

export default careerBn;


